import { Injectable } from '@angular/core';
import { HttpService } from '../core/http/http.service';
import { IPremisesLocationType, IPremises, ISiteType, IStore, IFloor } from '../_entities';

@Injectable()
export class PremisesService {
    private siteTypeUrl = 'api/sitetype';
    private premisesLocationUrl = 'api/premiseslocation';

    constructor(private httpService: HttpService) { }

	getPremises(id: number): Promise<IPremises> {

        return new Promise((resolve, reject) => {
            this.httpService.get<IPremises>(this.getPremisesUrl(id))
                .then(result => { resolve(result) }, error => reject(error));
        });
    }

    getSiteTypes(): Promise<ISiteType[]> {
        return new Promise((resolve, reject) => {
            this.httpService.get<ISiteType[]>(this.siteTypeUrl)
                .then(result => { resolve(result) }, error => reject(error));
        });
    }
    getLocationTypes(): Promise<IPremisesLocationType[]> {
        return new Promise((resolve, reject) => {
            this.httpService.get<IPremisesLocationType[]>(this.premisesLocationUrl)
                .then(result => { resolve(result) }, error => reject(error));
        });
    }

    private getPremisesUrl(premisesIdentifier: number) {
        return "/api/premises/" + premisesIdentifier;
    }


	patchPremises(premises: IPremises, prop: string, value: any): Promise<IPremises> {
		const patches = [
			{ "op": "replace", "path": `/${prop}`, "value": value }
		];
		return this.httpService.patch<IPremises>(`/api/premises/${premises.id}`, patches);
	}

	//FLOORS 

	getPremisesFloors(premisesId: string): Promise<IFloor[]> {
		return new Promise((resolve, reject) => {
			this.httpService.get<IFloor[]>("/api/" + premisesId + "/premises/floor")
				.then(result => { resolve(result) }, error => reject(error));
		});
	}

	patchFloor(premisesId: number, floorId: number, prop: string, value: any): Promise<IFloor> {
		const patches = [
			{ "op": "replace", "path": `/${prop}`, "value": value }
		];
		return this.httpService.patch<IFloor>(`/api/premises/${premisesId}/floor/${floorId}`, patches);
	}

	addFloor(premisesId: number, floorIdx: number): Promise<IFloor> {
		var data = { index: floorIdx, name: "" };
		return this.httpService.post<IFloor>(`/api/premises/${premisesId}/floor`, data);
	}

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/premises.service.ts